const styles = `:host{border-top:1px solid;border-color:var(--goto-border-color-default);height:1px;margin:.5rem 0;display:flex}`;export default styles;